import useConvTag from './use-conv-tag';
import useCustomerTag from './use-customer-tag';
import useCallTag from './use-call-tag';

export default { useConvTag, useCustomerTag, useCallTag };

export { useConvTag, useCustomerTag, useCallTag };
